import {RootState} from "../../../../app/store";


export const getRestorePasswordState = (state: RootState) => state.resetPasswordEmail;